import type { ClientOfferReviewLayoutStep } from '../../client-offer-review';

// List/map split ratio per layout step, keyed via the map panel's chevron
// buttons (`onLayoutStepChange`) — same ratios as the mockup reference's
// GRID_TEMPLATE_COLUMNS (client-offer-review.mockup.tsx).
export const GRID_TEMPLATE_COLUMNS: Record<ClientOfferReviewLayoutStep, string> = {
  wideList: 'minmax(480px,85fr) minmax(320px,15fr)',
  balanced: 'minmax(420px,50fr) minmax(420px,50fr)',
  wideMap: 'minmax(440px,15fr) minmax(480px,85fr)',
};
